<template>
    <div class="page-container">
        <el-card class="box-card">
            <el-form :inline="true" :model="queryParams" class="demo-form-inline">
                <el-form-item label="角色名称">
                    <el-input clearable v-model="queryParams.name" placeholder="请输入角色名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" @click="btnSearch">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="btnReset">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <div style="height: 10px;"></div>
        <el-card class="box-card">
            <el-button type="success" icon="el-icon-plus" @click="handleAdd(null)" size="mini" plain>新增</el-button>
            <div style="height: 10px;"></div>
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column type="index" label="编号" width="100"></el-table-column>
                <el-table-column prop="mark" label="角色标识"></el-table-column>
                <el-table-column prop="name" label="角色名称"></el-table-column>
                <el-table-column prop="description" label="角色描述"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
                <el-table-column align="center" label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit-outline" @click="handleAdd(scope.row)"></el-button>
                        <el-button type="text" icon="el-icon-document" @click="handlerAuth(scope.row)"></el-button>
                        <el-button v-if="scope.row.mark!=='TEACHER' && scope.row.mark!=='STUDENT'"  type="text" icon="el-icon-delete"
                                   @click="handleDelete(scope.row.id)"></el-button>

                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top:10px;"
                           background
                           layout="total,prev, pager, next"
                           @current-change="currentChange"
                           :total="total">
            </el-pagination>
        </el-card>

        <!--新增弹窗-->
        <el-dialog :title="form.id?'修改角色':'新增角色'" :visible.sync="dialogVisible" width="30%">
            <el-form :model="form" ref="form" label-width="120px" :rules="rules">
                <el-form-item label="角色名称" prop="name">
                    <el-input v-model="form.name" placeholder="请输入角色名称" clearable>
                    </el-input>
                </el-form-item>
                <el-form-item label="角色标识" prop="mark">
                    <el-input v-model="form.mark" placeholder="请输入角色标识" clearable>
                        <template slot="prepend" v-if="!form.id">ROLE_</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="角色描述">
                    <el-input v-model="form.description" type="textarea" placeholder="请输入角色描述"
                              :autosize="{minRows: 4, maxRows: 4}"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                    <el-button @click="close">取 消</el-button>
                    <el-button type="primary" @click="btnSubmit('form')">确 定</el-button>
                </span>
        </el-dialog>

        <!-- 页面权限 -->
        <el-dialog
            title="页面权限"
            width="500px"
            :modal-append-to-body="true"
            :append-to-body="true"
            :close-on-click-modal="false"
            :visible="authUserVisible"
            :before-close="handleAuthUserClose">
            <div class="wrapper" element-loading-text="正在加载角色菜单关联信息">
                <el-tree ref="menuTree"
                         :data="menuTree" node-key="id"
                         :props="treeProps"
                         :default-expand-all="true"
                         accordion :default-checked-keys="menuCheckIds" show-checkbox>
                </el-tree>
            </div>
            <div slot="footer">
                <el-button
                    type="danger"
                    @click="handleAuthUserClose()"
                    size="small"
                    icon="el-icon-error">
                    取消
                </el-button>
                <el-button
                    type="success"
                    @click="saveAuthUser()"
                    size="small"
                    icon="el-icon-success">
                    保存
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {reqDeleteRole, reqGetMenuListByRoleId, reqInsertRole, reqListRole, reqRoleAuthMenu, reqUpdateRole} from "@/api/system/role";
import {reqListMenu, reqListMenuTree} from "@/api/system/menu";

export default {
    name: 'tenant',
    async created() {
        await this.load();
        await this.loadMenuTree();
    },
    methods: {
        // 获取表格数据
        async load() {
            // 开启加载框
            this.loading = true
            this.tableData = [];
            let data = await reqListRole(this.queryParams);
            // 赋值数据参数
            this.tableData = data.records;
            this.total = data.total;
            // 关闭等待框
            this.loading = false
        },
        async loadMenuTree() {
            let data = await reqListMenuTree();
            this.menuTree = data;
        },
        // 点击查询按钮
        async btnSearch() {
            this.queryParams.currentPage = 1
            await this.load()
        },
        // 点击重置按钮
        async btnReset() {
            this.queryParams = {currentPage: 1, pageSize: 10};
            await this.load();
        },
        currentChange(num) {
            this.queryParams.currentPage = num;
            this.load();
        },
        handleAdd(item) {
            if (item) {
                this.form = JSON.parse(JSON.stringify(item));
            }
            this.dialogVisible = true;
        },
        async handlerAuth(row) {
            let id = row.id;
            let data = await reqGetMenuListByRoleId(id);
            this.authMenu.roleId = id;
            this.authUserVisible = true;
            // 确保弹窗渲染完成后再设置选中状态
            this.$nextTick(() => {
                if (this.$refs.menuTree) {
                    // 清空之前的选择状态
                    this.$refs.menuTree.setCheckedKeys([]);
                    // 设置新的选择状态
                    this.$refs.menuTree.setCheckedKeys(data);
                }
            });
        },
        handleAuthUserClose() {
            this.authUserVisible = false;
        },
        async saveAuthUser() {
            // 获取所有选中的节点
            const checkedKeys = this.$refs.menuTree.getCheckedKeys();
            // 获取半选中的节点（通常是父节点）
            const halfCheckedKeys = this.$refs.menuTree.getHalfCheckedKeys();
            // 如果你只想保存叶子节点，可以只使用checkedKeys
            // 或者根据业务逻辑决定是否包含半选节点
            this.authMenu.menuIdList = checkedKeys;
            let msg = await reqRoleAuthMenu(this.authMenu);
            this.$message.success(msg);
            this.handleAuthUserClose();
            await this.load();
        },
        close() {
            this.dialogVisible = false;
        },
        async btnSubmit(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    this.form.id ? await reqUpdateRole(this.form) : await reqInsertRole(this.form);
                    this.$message.success("操作成功");
                    this.dialogVisible = false;
                    await this.load();
                }
            });
        },

        handleDelete(id) {
            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(async () => {
                await reqDeleteRole(id);
                this.$message.success("操作成功");
                await this.load();
            });
        },
    },
    data() {
        return {
            queryParams: {
                currentPage: 1,
                pageSize: 10,
            },
            tableData: [],
            total: 0,
            dialogVisible: false,
            form: {},
            rules: {
                name: [
                    {required: true, message: '请输入角色名称', trigger: 'blur'},
                    {min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur'}
                ],
                mark: [
                    {required: true, message: '请输入角色标识', trigger: 'blur'},
                    {min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur'}
                ]
            },
            menuTree: [],
            menuCheckIds: [],
            authUserVisible: false,
            treeProps: {
                children: 'children',  // 子节点的字段名
                label: 'name',        // 节点标签的字段名
                disabled: 'disabled'  // 禁用状态的字段名（可选）
            },
            authMenu: {
                roleId: null,
                menuIdList: [],
            },
        }
    },
}
</script>
<style scoped>
.form-row {
    display: flex;
    flex-wrap: wrap;
}
</style>
